import { render, staticRenderFns } from "./RoleEditForm.vue?vue&type=template&id=13240f74&scoped=true&"
import script from "./RoleEditForm.vue?vue&type=script&lang=ts&"
export * from "./RoleEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./RoleEditForm.vue?vue&type=style&index=0&id=13240f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13240f74",
  null
  
)

export default component.exports